import Role from '../models/Role';
import api from './api';

export async function getAll(): Promise<Role[]> {
  const response = await api.get<Role[]>('roles');

  return response.data;
}
